<template>
  <v-card
    class="pa-5"
    :style="{ border: '1px solid var(--primary-boarder-color)' }"
    @click="goToTask"
  >
    <v-row class="d-flex flex-row align-center justify-space-between">
      <v-col cols="6" class="text-left">
        <v-chip
          class="ma-1 text-uppercase font-weight-medium"
          :color="getStatusColors(task.status).chip"
          :text-color="getStatusColors(task.status).text"
          elevated
          size="large"
          >{{ task.status }}</v-chip
        >
      </v-col>
      <v-col cols="6" class="text-right">
        <v-icon color="grey pa-1">mdi-clock-outline</v-icon>
        <span class="grey--text darken-2 px-2">{{ task.due_at }}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <span class="title font-weight-regular">{{ task.task_title }}</span>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { getStatusColors } from "@/utility/statusColors.js";
export default {
  name: "TaskCard",
  props: {
    task: Object,
  },
  methods: {
    getStatusColors(status) {
      return getStatusColors(status);
    },
    goToTask() {
      const uuid = this.task.uuid;
      this.$router.push({ name: "TaskInfo", params: { uuid } });
    },
  },
};
</script>
